import React from "react";
//#region types
import { ACTION_SEPARATOR } from "models/propTypes/menuPropTypes";
import { DocumentFormTypes } from "models/formTypes";
import { TranslationKeys } from "translations";
import { WintSuperkollAPIModelCustomFilters } from "wint-api-client/dist/types";
import { ReportConstants } from "utils/constants";
//#endregion
//#region components
import {
  DashboardButtonGroup,
  FilterButton,
  PageLayouts,
  ReloadEvent,
  ReportSearchInput,
  SearchContextProvider,
  useCheckRelations,
} from "components/common";
import { Grid } from "@mui/material";
import SIEFilesList from "./list";
import useSIEFilesReportFilterDefinition from "./forms/useReportFilterDefinition";
import CreateSIEFileButton from "./createButton";
import ExportSIEFileButton from "./exportButton";
import { useDocumentService } from "serviceHooks";
import useSIEFilesPermissions from "./hooks/useSIEFilesPermissions";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const SIEFilesReport: React.FC = () => {
  const documentService = useDocumentService();

  const { hasSieFileViewPermissions } = useSIEFilesPermissions();
  const { getIsAdmin } = useCheckRelations();
  const isAdmin = getIsAdmin();

  const {
    filterFormFields: reportFilterDefinition,
    filterQueryStateHandler,
    apiToReportFilterFormatter,
  } = useSIEFilesReportFilterDefinition();

  const getButtons = (reload: () => void) => {
    const result: (React.ReactElement | "ACTION_SEPARATOR")[] = [
      <ReportSearchInput
        placeholder={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Document.SearchFiles)}
      />,
      <ExportSIEFileButton onCreateSuccess={reload} />,
    ];
    if (isAdmin) {
      result.push(<CreateSIEFileButton onCreateSuccess={reload} />);
    }
    result.push(ACTION_SEPARATOR);
    result.push(<FilterButton />);
    return result;
  };
  return (
    <ReloadEvent
      uniqueKey={ReportConstants.ReportKeys.SIE}
      render={(reloadKey, reload) => (
        <SearchContextProvider>
          <PageLayouts.DashboardLayout<DocumentFormTypes.SIEFilter>
            entityKey={0}
            hasPermissions={hasSieFileViewPermissions()}
            title={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Document.SIEFiles)}
            topRightButtons={<DashboardButtonGroup buttons={getButtons(reload)} />}
            filterFields={reportFilterDefinition}
            filterQueryStateHandler={filterQueryStateHandler}
            apiToReportFilterFormatter={apiToReportFilterFormatter}
            reportToAPIFilterFormatter={documentService.reportToAPIFilterSIE}
            filterCategory={WintSuperkollAPIModelCustomFilters.FilterCategory.SIE}
          >
            <Grid container item>
              <SIEFilesList reloadKey={reloadKey} />
            </Grid>
          </PageLayouts.DashboardLayout>
        </SearchContextProvider>
      )}
    />
  );
};

export default SIEFilesReport;
